/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcribe_Too_Many_RequestsInputs */

const en_us2_transcribe_too_many_requests = /** @type {(inputs: Transcribe_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've dictated a lot in the last hour. Wait a bit, or type your message.`)
};

const pt_br2_transcribe_too_many_requests = /** @type {(inputs: Transcribe_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você ditou bastante na última hora. Espere um pouco ou digite a mensagem.`)
};

const es_419_transcribe_too_many_requests = /** @type {(inputs: Transcribe_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dictaste mucho en la última hora. Espera un poco o escribe tu mensaje.`)
};

const pt_pt2_transcribe_too_many_requests = /** @type {(inputs: Transcribe_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditaste bastante na última hora. Espera um pouco ou escreve a mensagem.`)
};

const fr_fr2_transcribe_too_many_requests = /** @type {(inputs: Transcribe_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu as beaucoup dicté dans la dernière heure. Patiente un peu, ou écris ton message.`)
};

const de_de2_transcribe_too_many_requests = /** @type {(inputs: Transcribe_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast in der letzten Stunde viel diktiert. Warte etwas oder tippe deine Nachricht.`)
};

const it_it2_transcribe_too_many_requests = /** @type {(inputs: Transcribe_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai dettato molto nell'ultima ora. Aspetta un po' o scrivi il messaggio.`)
};

/**
* | output |
* | --- |
* | "You've dictated a lot in the last hour. Wait a bit, or type your message." |
*
* @param {Transcribe_Too_Many_RequestsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const transcribe_too_many_requests = /** @type {((inputs?: Transcribe_Too_Many_RequestsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcribe_Too_Many_RequestsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_transcribe_too_many_requests(inputs)
	if (locale === "es-419") return es_419_transcribe_too_many_requests(inputs)
	if (locale === "pt-PT") return pt_pt2_transcribe_too_many_requests(inputs)
	if (locale === "fr-FR") return fr_fr2_transcribe_too_many_requests(inputs)
	if (locale === "de-DE") return de_de2_transcribe_too_many_requests(inputs)
	if (locale === "it-IT") return it_it2_transcribe_too_many_requests(inputs)
	return en_us2_transcribe_too_many_requests(inputs)
});
export { transcribe_too_many_requests as "transcribe.too_many_requests" }